var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-calendar" },
    [
      _c(
        "app-calendar-header",
        {
          attrs: {
            "current-month": _vm.currentMonth,
            "first-day": _vm.firstDay,
            locale: _vm.locale
          },
          on: { change: _vm.emitChangeMonth }
        },
        [
          _c("template", { slot: "header-left" }, [_vm._t("header-left")], 2),
          _c("template", { slot: "header-right" }, [_vm._t("header-right")], 2)
        ],
        2
      ),
      _c("div", { staticClass: "app-calendar-body" }, [
        _c(
          "div",
          { staticClass: "weeks" },
          _vm._l(7, function(day, index) {
            return _c("strong", { key: index, staticClass: "week" }, [
              _vm._v(
                _vm._s(_vm._f("localeWeekDay")(index, _vm.firstDay, _vm.locale))
              )
            ])
          }),
          0
        ),
        _c("div", { ref: "dates", staticClass: "dates" }, [
          _c(
            "div",
            { staticClass: "dates-background" },
            _vm._l(_vm.currentDates, function(week, index) {
              return _c(
                "div",
                { key: week + "-" + index, staticClass: "week-row" },
                _vm._l(week, function(day) {
                  return _c(
                    "div",
                    { staticClass: "day-cell", class: _vm.dayClass(day) },
                    [
                      _c("p", { staticClass: "day-number" }, [
                        _vm._v(_vm._s(day.monthDay))
                      ])
                    ]
                  )
                }),
                0
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "dates-events" },
            _vm._l(_vm.currentDates, function(week, weekIndex) {
              return _c(
                "div",
                { key: weekIndex, staticClass: "events-week" },
                _vm._l(week, function(day, dayIndex) {
                  return _c(
                    "div",
                    {
                      key: weekIndex + "-" + dayIndex,
                      staticClass: "events-day",
                      class: _vm.dayClass(day),
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.dayClick(day.date, $event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "is-flex",
                          style: { "justify-content": "space-between" }
                        },
                        [
                          _c(
                            "p",
                            [
                              _vm._t("day-header", null, {
                                events: day.events,
                                day: day
                              })
                            ],
                            2
                          ),
                          _c("p", { staticClass: "day-number" }, [
                            _vm._v(_vm._s(day.monthDay))
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "event-box" },
                        [
                          _vm._l(day.events, function(event, eventIndex) {
                            return _c("app-calendar-event-card", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: event.cellIndex <= _vm.eventLimit,
                                  expression: "event.cellIndex <= eventLimit"
                                }
                              ],
                              key:
                                weekIndex + "-" + dayIndex + "-" + eventIndex,
                              attrs: {
                                event: event,
                                date: day.date,
                                "first-day": _vm.firstDay
                              },
                              on: { click: _vm.eventClick },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(props) {
                                      return [
                                        _vm._t("event-card", null, {
                                          event: props.event
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          }),
                          day.events.length > _vm.eventLimit
                            ? _c(
                                "p",
                                {
                                  staticClass: "more-link",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.selectThisDay(day, $event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "+ " +
                                      _vm._s(
                                        day.events[day.events.length - 1]
                                          .cellIndex - _vm.eventLimit
                                      ) +
                                      " más"
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                }),
                0
              )
            }),
            0
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMore,
                  expression: "showMore"
                }
              ],
              staticClass: "more-events",
              style: _vm.moreEventsStyle
            },
            [
              _c("div", { staticClass: "more-header is-flex" }, [
                _c(
                  "span",
                  { staticClass: "title is-6 has-text-centered is-marginless" },
                  [_vm._v(_vm._s(_vm.moreTitle(_vm.selectDay.date)))]
                ),
                _c(
                  "span",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.showMore = false
                      }
                    }
                  },
                  [
                    _c("b-icon", { attrs: { size: "is-small", icon: "close" } })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "more-body" }, [
                _c(
                  "ul",
                  { staticClass: "body-list" },
                  _vm._l(_vm.selectDay.events, function(event, eventIndex) {
                    return _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: event.isShow,
                            expression: "event.isShow"
                          }
                        ],
                        key: eventIndex,
                        staticClass: "body-item",
                        on: {
                          click: function($event) {
                            return _vm.eventClick(event, $event)
                          }
                        }
                      },
                      [
                        _vm._v(_vm._s(event.title)),
                        _vm._t("event-card", null, { event: event })
                      ],
                      2
                    )
                  }),
                  0
                )
              ]),
              _vm._t("body-card")
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }